import http from "./http";
const baseUrl = "/v1/api/app";

const { get, post } = http;
const getAiModelPage = (params: any) => post(`${baseUrl}/ai/model/page`, params); // 列表
const createAiModel = (params: any) => post(`${baseUrl}/ai/model/create`, params); // 新增
const deleteAiModel = (params: any) => post(`${baseUrl}/ai/model/delete`, params); // 删除

const getAiModelDetail = (params: any) => post(`${baseUrl}/ai/model/detail`, params); // 详情
const saveAiModel = (params: any) => post(`${baseUrl}/ai/model/save`, params); // 保存
const existAiModelVersion = (params: any) => post(`${baseUrl}/ai/model/version/exist`, params); // 版本号校验
const saveNextAiModel = (params: any) => post(`${baseUrl}/ai/model/next/save`, params); // 保存并下一步
const auditReleaseAiModel = (params: any) => post(`${baseUrl}/ai/model/audit/release`, params); // 审核上架
const auditUpgradeAiModel = (params: any) => post(`${baseUrl}/ai/model/audit/upgrade`, params); // 审核升级
const cancelReleaseAiModel = (params: any) => post(`${baseUrl}/ai/model/cancel/release`, params); // 撤销上架
const cancelUpgradeAiModel = (params: any) => post(`${baseUrl}/ai/model/cancel/upgrade`, params); // 撤销升级
const cancelDownAiModel = (params: any) => post(`${baseUrl}/ai/model/cancel/down`, params); // 撤销下架
const upgradeVersionAiModel = (params: any) => post(`${baseUrl}/ai/model/version/upgrade`, params); // 升级版本
const auditDownAiModel = (params: any) => post(`${baseUrl}/ai/model/audit/down`, params); // 审核下架

const getAgentDetail = (params: any) => post(`${baseUrl}/ai/model/detail`, params); // 智能体详情
const checkAgentPackageName = (params: any) => post(`${baseUrl}/ai/model/packageName/exist`, params); // 智能体包名校验

export default {
  getAiModelPage,
  createAiModel,
  deleteAiModel,
  getAiModelDetail,
  saveAiModel,
  existAiModelVersion,
  saveNextAiModel,
  auditReleaseAiModel,
  auditUpgradeAiModel,
  cancelReleaseAiModel,
  cancelUpgradeAiModel,
  cancelDownAiModel,
  upgradeVersionAiModel,
  auditDownAiModel,
  getAgentDetail,
  checkAgentPackageName,
};
